import { useIntl } from 'react-intl';

import {
    TOTAL_VISITS_KEY,
    VisitStatisticTotals,
    VisitStatisticTotalsKey,
    VisitTranslationMap,
} from 'src/features/statistic/types';
import { statisticMessages } from 'src/features/statistic/utils/messages';
import { GeneralBlock } from 'src/registry/components/blocks/GeneralBlock';
import GeneralMessageBlock from 'src/registry/components/blocks/GeneralMessageBlock';
import { SectionBlockTitle } from 'src/registry/components/blocks/SectionBlock';
import { ICON_MAP } from 'src/utils/constants';
import PieChart from 'src/features/statistic/components/chart/PieChart';
import React from 'react';
import { Skeleton } from 'src/registry/ui/Skeleton';
import { RADIAL_BAR_FILLS } from 'src/features/home/types';
import StatisticValue from 'src/registry/components/statistic/StatisticValue';

type Props = {
    isLoading: boolean;
    data?: VisitStatisticTotals;
};

type FormattedData = {
    title: string;
    value: number;
}[];

export default function WidgetTotalVisits({ isLoading, data }: Props) {
    const { formatMessage } = useIntl();

    const formattedData: FormattedData = React.useMemo(() => {
        if (!data) return [];
        return Object.entries(data)
            .filter(([key, value]) => value > 0 && key !== TOTAL_VISITS_KEY)
            .map(([key, value]) => ({
                title: formatMessage(VisitTranslationMap[key as VisitStatisticTotalsKey]),
                value,
            }));
    }, [data]);

    return (
        <GeneralBlock className="min-h-110 flex-1">
            <SectionBlockTitle>{formatMessage(statisticMessages.totalVisits)}</SectionBlockTitle>
            {isLoading ? (
                <Skeleton className="h-90" />
            ) : data ? (
                <div className="flex h-full w-full justify-center gap-2 px-10">
                    <PieChart data={formattedData} dataKey="value">
                        <StatisticValue
                            className="text-center"
                            title={formatMessage(statisticMessages.totalVisits)}
                            value={data.total_visits_count}
                        />
                    </PieChart>
                    <div className="flex flex-col gap-1">
                        {formattedData?.map(({ title }, i) => {
                            return (
                                <div key={i} className="flex items-center gap-2">
                                    <div
                                        style={{
                                            backgroundColor: RADIAL_BAR_FILLS[i % RADIAL_BAR_FILLS.length],
                                            width: 10,
                                            height: 10,
                                            borderRadius: 50,
                                        }}
                                    />
                                    <span>{title}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ) : (
                <GeneralMessageBlock
                    icon={ICON_MAP.SEARCH}
                    title={formatMessage(statisticMessages.noPaymentsFound)}
                    subtitle={formatMessage(statisticMessages.chooseDifferentPeriod)}
                />
            )}
        </GeneralBlock>
    );
}
